import * as z from "zod/v4";

export const createOmsApparelMagicIntegration = {
  name: "createOmsApparelMagicIntegration" as const,
  input: z.object({ apiKey: z.string(), companyId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
